import React, {useEffect, useState, } from 'react';
import { Table, Input, Space, Row, Typography, Button, Tooltip, } from 'antd';
import { useNavigate, Link } from "react-router-dom"
import { SearchOutlined, } from '@ant-design/icons';

const { Title } = Typography;

export const AdvancedSearchTable = ({pendingState, dataSource, query, setDisplayModal, ...other}) => {
    
    const navigate = useNavigate();
    const [queryResults, setQueryResults] = useState(dataSource);
    const [search, setSearch] = useState('');
    const [filteredResults, setFilteredResults] = useState('');
    const [count, setCount] = useState(search ? filteredResults.length : queryResults.length);

    const sorter = (a, b) => {
        if (a === null) {
            return 1;
        }
        
        if (b === null) {
            return -1;
        }
        
        if (a === b) {
            return 0;
        }
        
        return a < b ? -1 : 1;
    }

    const columns = [
        {
            title: 'Serial Number', 
            dataIndex: 'deviceSerialNum',
            sorter: (a, b) => sorter(a.deviceSerialNum, b.deviceSerialNum),
            render: (text) => { return text || 'N/A' }
        },
        {
            title: 'Device Type', 
            dataIndex: 'deviceType',
            sorter: (a, b) => sorter(a.deviceType, b.deviceType),
            render: (text) => { return text || 'N/A' }
        },

        {
            title: 'Customer',
            dataIndex: 'customerCompanyName',
            sorter: (a, b) => sorter(a.customerCompanyName, b.customerCompanyName),
            render: (text) => { return text || 'N/A' }
        },
        {
            title: 'Location', 
            dataIndex: 'locationName',
            sorter: (a, b) => sorter(a.locationName, b.locationName),
            render: (text) => { return text || 'N/A' }
        }, 
        {
            title: 'Description', 
            dataIndex: 'deviceDescription',
            sorter: (a, b) => sorter(a.deviceDescription, b.deviceDescription),
            render: (text) => { return text || 'N/A' }
        },
        {
            title: 'VPN IP', 
            dataIndex: 'deviceIP',
            sorter: (a, b) => sorter(a.deviceIP, b.deviceIP),
            render: (text) => { return text || 'N/A' }
        },
        {
            title: 'VPN Status', 
            dataIndex: 'deviceStatus',
            // render: (text) => { return text || '' }
            render: (text) => {return (text ? 'ON' : 'OFF')}
        },
        {
            dataIndex: 'action',
            render: (_, record) => {
                return ( pendingState ? 
                    <Tooltip title={pendingState && 'Pending changes must be cleared'}>
                        <Button disabled={pendingState} size='small' onClick={ () => { setDisplayModal(false); navigate(`/station?=${record.user.id}&id=${record.stationID}`) }} type='link'>View</Button>
                    </Tooltip>
                    : 
                    <Link 
                        to={{
                                pathname: '/app/station', 
                                search: `${record.user.id}&id=${record.stationID}`,
                            }}
                        state={{
                            currentNocItem: {...record.user},
                            advancedSearch: true
                        }}
                    
                    >
                        <Button disabled={pendingState} size='small' onClick={ () => { setDisplayModal(false); navigate(`/station?=${record.user.id}&id=${record.stationID}`) }} type='link'>View</Button>
                    </Link>)
            }
        },
    ];
    
    useEffect(() => {
        setQueryResults(dataSource);
    }, [dataSource])

    useEffect(() => {
        setFilteredResults(queryResults.filter(item => {
            let regEx = new RegExp(search.toLowerCase(), 'g');
            return regEx.test(Object.entries(item).map(([key, value]) => ['', value === null ? '' : value.toString().toLowerCase()]))
        }));

        setCount(search ? filteredResults.length : queryResults.length);
        
    }, [dataSource, queryResults, search, filteredResults.length]);

    useEffect(() => {
        setSearch('');
    }, [query]);

    return(
        <>  
            <Row justify='space-between' align='middle' style={{marginBottom: 10}}>
                <Title level={5}>{dataSource.length} Results found "{query.query.toUpperCase()}"</Title>
                <Space>
                    <p>Search:</p>
                    <Input suffix={<SearchOutlined/>} allowClear onChange={(e) => setSearch(e.target.value)} value={search}/>
                </Space>
            </Row>
            <Table
                rowKey='deviceSerialNum'
                size='small'
                columns={columns}
                dataSource= {search !== '' ? filteredResults : queryResults}
                scroll={{ x: 350 }}
                style={{margin: 0, padding: 0,}}
                pagination={
                        {
                            total: search ? filteredResults.length : queryResults.length, 
                            defaultCurrent: 1, 
                            showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items${search ? ` containing "${search}". Results filtered from ${queryResults.length} entries` : ''}`,
                            showSizeChanger: true,
                            showQuickJumper: true
                        }
                    }
            />
            {search && filteredResults.length === 0 ?
                <p>0 matching results containing "{search}" in {query.query}.</p> : '' 
            }
        </>
    );
}